module.exports = __webpack_public_path__ + "static/UnboundWorldsApart4-bdb69ab43f5716af932e46477dd8b950.webp";